import { useState } from "react";

import { makePostApiCall, makePutApiCall } from "../../../shared/makeApiCall";
import CoreMarkSkusForm from "../../../components/forms/setup/sunCoreMarkSkus/CoreMarkSkusForm";
import { BannerNotificationType } from "../../../components/SimpleBanner";
import DeleteConfirmationForm from "../../../components/forms/DeleteConfirmationForm";

export function SunCoreMarkSkusViewModel(logout) {
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [coreMarkSkus, setCoreMarkSkus] = useState({ data: [] });

  const [showSimpleNotification, setShowSimpleNotification] = useState({
    show: false,
    message: null,
    title: null,
    type: BannerNotificationType.Success,
  });
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });

  const user_id = localStorage.getItem("id");

  const getSunCoreMarkSkus = async function (search, page) {
    setLoading(true);
    const payload = {
      page: page,
      search: search,
    };
    let callResult = await makePostApiCall(`sunCoreMarkSkus`, payload);
    setLoading(false);
    if (callResult.success) {
      setCoreMarkSkus(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const createCoreMarkSku = async function (values) {
    const payload = { ...values, user_id: user_id };
    let callResult = await makePostApiCall("createSunCoreMarkSku", payload);

    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        title: "CoreMark SKU added",
        type: BannerNotificationType.Success,
      });
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getSunCoreMarkSkus("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const updateCoreMarkSku = async function (coreMarkSku, values, index) {
    const payload = { ...values, id: coreMarkSku.id };
    let callResult = await makePutApiCall(
      `sunCoreMarkSkus/${coreMarkSku.id}`,
      payload
    );

    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        title: "CoreMark SKU updated",
        type: BannerNotificationType.Success,
      });
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getSunCoreMarkSkus("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const openAddCoreMarkSkuSlideOver = () => {
    setSlideOver({
      childComponent: (
        <CoreMarkSkusForm
          isEdit={false}
          setOpen={setSlideOver}
          actionCall={createCoreMarkSku}
        />
      ),
      open: true,
    });
  };

  const viewCoreMarkSkuDetails = async function (coreMarkSku, index) {
    setSlideOver({
      childComponent: (
        <CoreMarkSkusForm
          coreMarkSku={coreMarkSku}
          index={index}
          isEdit={true}
          setOpen={setSlideOver}
          actionCall={updateCoreMarkSku}
        />
      ),
      open: true,
    });
  };

  const deleteCoreMarkSku = async function (id, index) {
    setLoading(true);

    let callResult = await makePostApiCall(`deleteSunCoreMarkSku/${id}`, {});
    setLoading(false);
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });
      getSunCoreMarkSkus("", 1);
      setShowSimpleNotification({
        show: true,
        title: callResult.data.message || "CoreMark SKU deleted",
        type: BannerNotificationType.Success,
      });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const askDeleteCoreMarkSku = function (coreMarkSku, index) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteCoreMarkSku(coreMarkSku.id, index)}
          message={`Are you sure you want to delete the SKU mapping for ${coreMarkSku.solmaz_plu}?`}
          setOpen={setEmptyModelOpen}
        />
      ),
      open: true,
    });
  };

  return {
    askDeleteCoreMarkSku,
    emptyModal,
    getSunCoreMarkSkus,
    loading,
    coreMarkSkus,
    openAddCoreMarkSkuSlideOver,
    setEmptyModelOpen,
    setSlideOver,
    setShowSimpleNotification,
    slideOver,
    showSimpleNotification,
    viewCoreMarkSkuDetails,
  };
}
